export default __webpack_public_path__ + "static/media/unit-added.690c66f6.svg";